











































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Dynamic extends Vue {
  @Prop()
  dynamic;
  mounted() {
    //
  }
}
